export enum ORGANIC_STATES {
  conventional = 'conventional',
  organic = 'organic',
  conversion = 'conversion',
}

export enum IMPORT_FROM {
  classic = 'classic-import',
  procedure = 'procedure-import',
}

export enum IMPORT_TYPE {
  csv = 'CSV',
  telepac = 'Telepac',
  apia = 'Apia',
  wiuz = 'Wiuz',
  geofolia = 'Geofolia',
}

export enum COLORS {
  grey = '#d2d2d2',
  green = '#277134',
  yellow = '#e69636',
  white = '#FFFFFF',
  black = '#000000',
  darkgray = '#646464ff',
  red = '#eb4d4b',
  errorText = '#d32f2f',
  blue = '#2563eb',
}

export enum CULTURE_TYPE {
  main = 'main',
  intermediate = 'intermediate',
}

export const CultureTypeLabels: Record<CULTURE_TYPE, string> = {
  [CULTURE_TYPE.main]: 'Principale',
  [CULTURE_TYPE.intermediate]: 'Intermédiaire',
};

// Use this with i18next's t function: getCultureTypeLabels(t)
export const getCultureTypeLabels = (
  t: (_key: string) => string,
): Record<CULTURE_TYPE, string> => ({
  [CULTURE_TYPE.main]: t('cultureType.main'),
  [CULTURE_TYPE.intermediate]: t('cultureType.intermediate'),
});

export enum CAP_CATEGORY {
  meddow_fallow = 'Prairies Temporaires Et Jachère',
  nitrogen_fixing = "Fixatrices d'Azote",
  div_cult = 'Cultures Diverses',
  winter_cereals = "Céréales d'hiver",
  spring_cereals = 'Céréales de printemps',
  weeded_plants = 'Plantes sarclées',
  winter_oilseeds = "Oléagineux d'hiver",
  spring_oilseeds = 'Oléagineux de printemps',
  lorem = 'Autre culture TA',
  permanent_grassland = 'Prairies Permanentes',
}
